exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-portal-client-tab-styles__tab {\n  height: 100%;\n  padding-left: 16px;\n  padding-right: 16px;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n}\n\n.src-client-portal-client-tab-styles__tab:hover {\n  background-color: #F7F7F7;\n  text-decoration: none;\n}\n\n.src-client-portal-client-tab-styles__tab:first-of-type {\n  margin-left: 16px;\n}\n\n.src-client-portal-client-tab-styles__tab:focus {\n  text-decoration: none;\n}\n\n.src-client-portal-client-tab-styles__text {\n  opacity: 0.5;\n  font-size: 14px;\n  color: #333333;\n}\n\n.src-client-portal-client-tab-styles__active {\n  font-weight: bold;\n  color: #00BF4B;\n  color: var(--cps-color-primary);\n  opacity: 1;\n}", ""]);

// exports
exports.locals = {
	"tab": "src-client-portal-client-tab-styles__tab",
	"text": "src-client-portal-client-tab-styles__text",
	"active": "src-client-portal-client-tab-styles__active"
};